import { render, staticRenderFns } from "./Bollettazione.vue?vue&type=template&id=d1244468"
import script from "./Bollettazione.vue?vue&type=script&lang=js"
export * from "./Bollettazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports